export const USER_TYPE = {
  USER: 'user',
  HCP: 'health-care-practitioner',
  PRACTITIONER: 'practitioner'
}
